;(function(win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var tid;
    function refreshScale(){
        var width = docEl.getBoundingClientRect().width;
        if(width>750){
            metaEl.content = "width=device-width,initial-scale=1.0";
        }else{
            metaEl.content = "width=device-width,initial-scale=0.9,user-scalable=no";
        }
    }

    win.addEventListener('resize', function() {
        clearTimeout(tid);
        tid = setTimeout(refreshScale, 300);
    }, false);

    win.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshScale, 300);
        }
    }, false);

    refreshScale();
})(window, window['lib'] || (window['lib'] = {}));


// WEBPACK FOOTER //
// ./src/config/resize.js